import { render } from "./SandboxJobDetail.vue?vue&type=template&id=31385711&scoped=true"
import script from "./SandboxJobDetail.vue?vue&type=script&lang=js"
export * from "./SandboxJobDetail.vue?vue&type=script&lang=js"

import "./SandboxJobDetail.vue?vue&type=style&index=0&id=31385711&scoped=true&lang=css"
import "./SandboxJobDetail.vue?vue&type=style&index=1&id=31385711&lang=scss"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31385711"]])

export default __exports__